export default (function () {
  if (typeof IntersectionObserver === 'undefined') {
    return;
  }

  return IntersectionObserver;
});